package com.anjuros.website.templates.template10.util

import com.anjuros.website.components.shared.CompanyDetailsType
import com.anjuros.website.components.shared.DetailsType
import com.anjuros.website.templates.template10.util.Template10Constants.CLASS_CITY1
import com.anjuros.website.templates.template10.util.Template10Constants.CLASS_CITY2
import com.anjuros.website.templates.template10.util.Template10Constants.CLASS_CITY3

enum class Template10CompanyDetails : CompanyDetailsType {
    CLIENTS_COMPANY_INFO {
        override fun value(): String = Template10Constants.CLIENTS_COMPANY
        override fun getType(): DetailsType = DetailsType.COMPANY
    },
    CLIENTS_NAME_INFO {
        override fun value(): String = Template10Constants.CLIENTS_NAME
        override fun getType(): DetailsType = DetailsType.COMPANY
    },
    CLIENTS_EMAIL_INFO {
        override fun value(): String = Template10Constants.CLIENTS_EMAIL
        override fun getType(): DetailsType = DetailsType.EMAIL
    },
    CLIENTS_PHONE_INFO {
        override fun value(): String = Template10Constants.CLIENTS_PHONE
        override fun getType(): DetailsType = DetailsType.COMPANY_PHONE
    },
    CLIENTS_COMPANY_NUMBER_INFO {
        override fun value(): String = Template10Constants.CLIENTS_COMPANY_NUMBER
        override fun getType(): DetailsType = DetailsType.COMPANY_NUMBER
    },
    CLIENTS_COMPANY_ADDRESS_INFO {
        override fun value(): String = Template10Constants.CLIENTS_COMPANY_ADDRESS
        override fun getType(): DetailsType = DetailsType.COMPANY_ADDRESS
    },
    CLIENTS_SERVICE_AREA1_INFO {
        override fun value(): String = CLASS_CITY1.first
        override fun getType(): DetailsType = DetailsType.COMPANY_SERVICE_AREA
    },
    CLIENTS_SERVICE_AREA2_INFO {
        override fun value(): String = CLASS_CITY2.first
        override fun getType(): DetailsType = DetailsType.COMPANY_SERVICE_AREA
    },
    CLIENTS_SERVICE_AREA3_INFO {
        override fun value(): String = CLASS_CITY3.first
        override fun getType(): DetailsType = DetailsType.COMPANY_SERVICE_AREA
    },
    CLIENTS_SERVICE_AREA_ADDRESS1_INFO {
        override fun value(): String = CLASS_CITY1.second
        override fun getType(): DetailsType = DetailsType.COMPANY_SERVICE_AREA_ADDRESS
    },
    CLIENTS_SERVICE_AREA_ADDRESS2_INFO {
        override fun value(): String = CLASS_CITY2.second
        override fun getType(): DetailsType = DetailsType.COMPANY_SERVICE_AREA_ADDRESS
    },
    CLIENTS_SERVICE_AREA_ADDRESS3_INFO {
        override fun value(): String = CLASS_CITY3.second
        override fun getType(): DetailsType = DetailsType.COMPANY_SERVICE_AREA_ADDRESS
    },
}
